module.exports = __webpack_public_path__ + "img/No_Available_Image.ae6dd4fa.png";